import { useLocation } from 'react-router-dom';
import { Route } from '../interface/Route';

/**
 * Returns the footer configuration for the currently matched route.
 *
 * This hook checks the current browser location (via `useLocation`) and finds
 * the first route in the provided array whose `path` matches the current
 * `location.pathname`. If the matching route contains a `footerConfig`, that
 * configuration is returned.
 *
 * If no route matches the current path, or if the matched route does not
 * define a `footerConfig`, a default footer configuration is returned instead.
 * The default configuration has all options (`pagging`, `grid`, and `rowsPerPage`)
 * set to `true`.
 *
 */

export function useFooterConfig(routes: Route[]) {
  const location = useLocation();
  return (
    routes.find((route) => route.path === location.pathname)?.footerConfig || {
      pagging: false,
      grid: false,
      rowsPerPage: false,
    }
  );
}
